/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for adding an MCP server to a meta MCP server's member set.
 */
export type AddMetaMcpMemberForm = {
  /**
   * The ID of the MCP server to add as a member
   */
  mcpServerId: string;
  /**
   * The ID of the meta MCP server
   */
  metaMcpServerId: string;
  /**
   * The position of the member in the ordered member set. Defaults to 0.
   */
  sortOrder?: number | undefined;
};

/** @internal */
export type AddMetaMcpMemberForm$Outbound = {
  mcp_server_id: string;
  meta_mcp_server_id: string;
  sort_order?: number | undefined;
};

/** @internal */
export const AddMetaMcpMemberForm$outboundSchema: z.ZodMiniType<
  AddMetaMcpMemberForm$Outbound,
  AddMetaMcpMemberForm
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
    metaMcpServerId: z.string(),
    sortOrder: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      metaMcpServerId: "meta_mcp_server_id",
      sortOrder: "sort_order",
    });
  }),
);

export function addMetaMcpMemberFormToJSON(
  addMetaMcpMemberForm: AddMetaMcpMemberForm,
): string {
  return JSON.stringify(
    AddMetaMcpMemberForm$outboundSchema.parse(addMetaMcpMemberForm),
  );
}
